import { render, staticRenderFns } from "./AdvisorRated.vue?vue&type=template&id=f168c050"
import script from "./AdvisorRated.vue?vue&type=script&lang=js"
export * from "./AdvisorRated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports